import { render, staticRenderFns } from "./pricereq.vue?vue&type=template&id=db1a43ca&scoped=true&"
import script from "./pricereq.vue?vue&type=script&lang=js&"
export * from "./pricereq.vue?vue&type=script&lang=js&"
import style0 from "./pricereq.vue?vue&type=style&index=0&id=db1a43ca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1a43ca",
  null
  
)

export default component.exports